<template>
  <component v-if="helpText" :is="tag" class="tooltip-btn" :class="[setColor, direction]" :data-c-tooltip-class="direction" v-bind="bindings" v-tooltip:[tooltipArg]="helpText">
    <icon :class="setIcon"></icon>
    <span class="sr-only">
      <slot>{{helpText}}</slot>
    </span>
  </component>
</template>

<script lang="ts">
  import Vue from "vue";
  import {Hash} from "~/interfaces/hashInterfaces";

  // default: "?" grey. mode "danger": "!" red
  export default Vue.extend({
    inheritAttrs: false,
    props: {
      text: {
        type: String,
        default: null,
      },
      // Use this instead of text prop when tooltip needs to be rendered as html
      html: {
        type: String,
        default: null,
        required: false
      },
      icon: {
        type: String,
        default: 'help',
      },
      color: {
        type: String,
        default: 'grey',
      },
      mode: {
        type: String,
        default: ''
      },
      tag: {
        type: String,
        default: 'button',
      },
      direction: {
        type: String,
        default: 'top',
      }
    },
    computed: {
      helpText(): string {
        if (this.html) return this.html
        return this.text ? this.text : this.$slots.default?.map(s => s.text).join(", ")
      },
      setIcon() {
        switch (this.mode) {
          case 'danger':
            return 'exclamation';
          default:
            return this.icon;
        }
      },
      setColor() {
        switch (this.mode) {
          case 'danger':
            return 'red';
          default:
            return this.color;
        }
      },
      bindings() {
        const props: Hash = {}
        if (this.tag === 'button') {
          props.type = 'button'
        }
        return {...this.$attrs, ...props}
      },
      isHtml(): boolean {
        return Boolean(this.html)
      },
      tooltipArg() {
        return {
          html: this.isHtml,
        }
      },
    },
  });
</script>

